import React from "react";
import BoardTabPane from "../common/BoardTabPane";
import { GRID_KEYS, TOP_TABS } from "../constants";
import { getPickDispatchObjectsStore } from "../services/DispatchManagementService";

/**
 * Pick tab - dispatch objects that need a trip and do not have one yet (Delphi tabTopDispatch,
 * caption "&Pick", over the uFMM0036 query).
 *
 * Its pending/warning bands are measured against SCHEDULEDPICKUPDT using the profile's
 * PENDINGLEVEL / WARNINGLEVEL; TAB_COLOR_BASIS holds that mapping.
 */
const PickTab = (props) => (
    <BoardTabPane
        {...props}
        topTab={TOP_TABS.PICK}
        gridKey={GRID_KEYS.PICK}
        storeFactory={getPickDispatchObjectsStore}
    />
);

export default PickTab;
